<div fxLayout="column">
    <div fxFlex="1 1 15vh" fxFlex.lt-md="1 1 auto" fxLayout="column">
        <!-- <div *ngIf="profileType === 'MULTI_ENTITY_NOSTRO'">
            <app-heartbeat-metric></app-heartbeat-metric>
        </div> -->
        <app-metric-bar fxFlex="1 1 auto" class="metrics" #metrics></app-metric-bar>
    </div>
    <div fxFlex="1 1 calc(85vh-70px)" fxFlex.lt-md="1 1 auto" fxLayout="column">
        <div fxFlex="0 0 auto" fxHide.lt-md="true" fxLayout="column" class="metric-bar"></div>
        <div fxFlex="1 1 auto" fxFlex.lt-md="1 1 auto" fxLayout="column" class="liq-dashboard">
            <!-- <app-metrics fxFlex="100 85 100%" #metrics></app-metrics> -->
            <div *ngIf="profileType !== 'MULTI_ENTITY_NOSTRO'" [fxHide]="mode != 'live' && mode != 'fixed'" fxFlex="1 1 auto" fxLayout="row"
                fxLayout.lt-md="column">
                <app-s-h-ladder #ladder [fxFlex]="shLadderFXFlex" class="liquitics-box"></app-s-h-ladder>
                <div *ngIf="(profileType === 'SINGLE_CURRENCY') && !showSHChart" fxFlex="0 0 20%" fxLayout="column" fxFlexOrder.lt-md="2">
                    <app-significant-ladder [title]="'Desk Forecasts'" [type]="'INTERNAL'" fxFlex="1 1 auto" class="liquitics-box"></app-significant-ladder>
                    <app-significant-ladder [title]="'Client Forecasts'" [type]="'EXTERNAL'" fxFlex="1 1 auto" class="liquitics-box"></app-significant-ladder>
                </div>
                <div fxFlex="0 1 60%" fxLayout="row" fxFlexOrder.lt-md="1">
                    <div fxFlex="1 1 auto" fxLayout="column">
                        <div fxFlex="1 1 40%" fxFlex.lt-md="auto" fxFlexOrder.lt-md="2" fxLayout="row" class="monitor-group">
                            <div fxFlex="1 1 100%" fxLayout="row" fxLayout.lt-md="column">
                                <app-projection #projection [fxFlex]="projectionFXFlex" fxFlex.lt-md="100%" class="liquitics-box"></app-projection>
                                <app-market-data *ngIf="showMarketData" #marketData fxFlex="2 3 100%" fxFlex.lt-md="100%" class="liquitics-box"></app-market-data>
                                <div *ngIf="profileType === 'SINGLE_CURRENCY'" fxFlex="0 1 60%" fxFlex.lt-md="100%" class="" fxLayout="row">
                                    <app-loro-ladder fxFlex="0 1 50%" class="liquitics-box"></app-loro-ladder>
                                    <app-nostro-ladder fxFlex="0 1 50%" class="liquitics-box"></app-nostro-ladder>
                                </div>
                            </div>
                        </div>
                        <app-detail #detail fxFlex="1 1 50vh" fxFlex.lt-md="1 1 auto" fxFlexOrder.lt-md="1" fxLayout="row" class="liquitics-box"></app-detail>
                    </div>
                </div>
            </div>
            <div *ngIf="profileType === 'MULTI_ENTITY_NOSTRO'" [fxHide]="mode != 'live' && mode != 'fixed'" fxFlex="1 1 70vh" fxLayout="row"
                fxLayout.lt-md="column">
                <app-five-day-ladder fxFlex="0 0 20%" class="liquitics-box"></app-five-day-ladder>
                <app-projection #projection fxFlex="0 0 20%" fxFlex.lt-md="100%" class="liquitics-box"></app-projection>
                <div fxFlex="0 0 60%" fxLayout="row" fxFlexOrder.lt-md="1">
                    <div fxFlex="1 1 auto" fxLayout="column">
                        <div fxFlex="1 1 40%" fxFlex.lt-md="auto" fxFlexOrder.lt-md="2" fxLayout="row" class="monitor-group">
                            <div fxFlex="1 1 auto" fxLayout="row" fxLayout.lt-md="column">
                                <div fxFlex="1 1 100%" fxFlex.lt-md="100%" class="" fxLayout="row">
                                    <app-significant-ladder [title]="'Desk Forecasts'" [type]="'INTERNAL'" fxFlex="0 0 35%" class="liquitics-box"></app-significant-ladder>
                                    <app-significant-ladder [title]="'Entity Forecasts'" [type]="'ENTITY'" fxFlex="0 0 35%" class="liquitics-box"></app-significant-ladder>
                                    <app-nostro-ladder fxFlex="0 0 30%" class="liquitics-box"></app-nostro-ladder>
                                </div>
                            </div>
                        </div>
                        <app-detail #detail fxFlex="1 1 50vh" fxFlex.lt-md="1 1 auto" fxFlexOrder.lt-md="1" fxLayout="row" class="liquitics-box"></app-detail>
                    </div>
                </div>
            </div>
            <div *ngIf="mode == 'compare'" fxFlex="1 1 auto" fxLayout="row" fxLayout.lt-md="column">
                <app-s-h-compare-ladder #compareladder fxFlex="0 1 70%" fxFlex.lt-md="auto" class="liquitics-box" [currency]="currency"></app-s-h-compare-ladder>
                <div fxFlex="0 1 30%" fxFlex.lt-md="auto" fxLayout="column">
                    <div fxFlex="0 1 auto" class="compare-currency-toggle">
                        <mat-button-toggle-group (change)="onCurrencySelected($event)">
                            <mat-button-toggle *ngFor="let ccy of currencies" [value]="ccy" [checked]="currency === ccy">
                                <span>{{ccy}}</span>
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    <app-compare-explain fxFlex="0 1 auto" [explainMode]="'compare'"></app-compare-explain>
                </div>
            </div>
            <div *ngIf="mode == 'account-balance'" fxFlex="1 1 100%" fxLayout="row" fxLayout.lt-md="column">
                <app-account-balance #accountbalance fxFlex="1 1 70%" fxFlex.lt-md="auto" class="liquitics-box"></app-account-balance>
                <div fxHide.lt-md="true" fxFlex="1 1 30%"></div>
            </div>
            <div [fxHide]="mode !== 'buffer'" fxFlex="1 1 100%" fxLayout="row" fxLayout.lt-md="column">
                <app-buffer #buffer fxFlex="1 1 auto" fxFlex.lt-md="auto" class="liquitics-box"></app-buffer>
            </div>
        </div>
    </div>
</div>